<template>
  <div class="s-content">
    <h3 class="account-sub-title d-none d-md-block">
      <i class="icon-secure-payment align-middle mr-3"></i>
      {{ translations.finances }}
    </h3>
    <div class="download-table-container">
      <div class="mb-2">
        <div class="date-range-wrapper d-flex flex-wrap flex-md-nowrap">
          <date-picker
            :placeholder="translations.from"
            v-model="dateFrom"
            :ranges="false"
            :disabled-date="disabledDatesFromDate"
            :clearable="false"
            input-class="form-control me-md-2 mb-2 mb-md-0"
          ></date-picker>
          <date-picker
            :placeholder="translations.to"
            :ranges="false"
            v-model="dateTo"
            :disabled-date="disabledDatesToDate"
            :clearable="false"
            input-class="form-control me-md-2 mb-2  mb-md-0"
          ></date-picker>
          <button
            type="button"
            class="btn btn-primary text-transform-none me-md-2 mb-2 mb-md-0"
            @click="getFinances"
          >
            {{ translations.show.toUpperCase() }}
          </button>
          <button
            class="btn btn-primary mb-2 mb-md-0 ml-md-auto"
            @click="generatePDF"
            :disabled="finances.length === 0"
          >
            {{ translations.print }}
          </button>
        </div>
      </div>
      <!--/Date range-->
    </div>
    <div class="order-table-container order-table-with-content">
      <table class="table table-order text-left" ref="pdfTable" id="pdfTable">
        <thead>
          <tr>
            <th>{{ translations.account.toUpperCase() }}</th>
            <th>{{ translations.docDate.toUpperCase() }}.</th>
            <th>{{ translations.bookingDateShort.toUpperCase() }}.</th>
            <th>{{ translations.accountNumber.toUpperCase() }}</th>
            <th>{{ translations.paymentTerm.toUpperCase() }}</th>
            <th class="text-right">{{ translations.claims.toUpperCase() }}</th>
            <th class="text-right">{{ translations.owes.toUpperCase() }}</th>
            <th class="text-right">{{ translations.amount.toUpperCase() }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item) in finances" :key="item.bookingNoteItemId">
            <td>{{ item.firstFinanceImportant ? '--' : item.chartOfAccountsAccount }}</td>
            <td>{{ item.firstFinanceImportant ? '--' : format(item.documentDate) }}</td>
            <td>{{ item.firstFinanceImportant ? '--' : format(item.deliveryDate) }}</td>
            <td>{{ item.firstFinanceImportant ? '--' :
              item.bookingNoteItemSupplierInvoiceNumber }}</td>
            <td>{{ item.firstFinanceImportant ? '--' : format(item.paymentDate) }}</td>
            <td class="text-right">
              {{ item.firstFinanceImportant ? '--' : item.debit.toFixed(2).replace('.', ',') }}</td>
            <td class="text-right">
              {{ item.firstFinanceImportant ? '--' :
                item.credit.toFixed(2).replace('.', ',') }}</td>
            <td class="text-right">
              {{ (item.firstFinanceImportant ? item.total : item.saldo) | money3 }}</td>
          </tr>
          <tr v-if="finances.length === 0">
            <td class="text-center" colspan="8">{{ translations.noDataToAccordingData }}</td>
          </tr>
        </tbody>
      </table>
      <div class="finance-total-info row">
        <p>{{ translations.yourTotalDebtIs }}:
          <span :class="{
            'accent-danger': totalSaldo > 0,
            'accent-primary': totalSaldo == 0
            }">{{ totalSaldo.toFixed(2).replace('.', ',') }}</span></p>
          <!-- <p>Dug van valute iznosi: <span class="accent-danger">-</span></p> -->
        <button class="btn btn-primary mr-4" :disabled="finances.length === 0"
        style="margin-left: auto;"
          @click="generatePDF">Print</button>
      </div>
      <iframe id="printFrame" style="display:none;"></iframe>
    </div>
  </div>
</template>

<script>
import { startOfYear, format } from 'date-fns';

import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

import { pager, translations } from '@/mixins';

export default {
  name: 'ProfileFinance',
  mixins: [pager, translations],
  components: {
    DatePicker,
  },
  data() {
    return {
      actionName: 'getFinances',
      currentOrder: null,
      dateFrom: startOfYear(new Date()),
      dateTo: new Date(),
    };
  },
  computed: {
    profile() {
      return this.$store.getters.getProfile;
    },
    loggedUser() {
      return this.$store.getters.getLoggedUser;
    },
    finances() {
      const finances = (this.$store.getters.getFinances);
      finances.forEach((item, index) => {
        finances.forEach((item2, index2) => {
          if (index2 <= index) {
            finances[index].saldo = finances[index].saldo + item2.debit - item2.credit;
          }
        });
      });
      return finances;
    },
    totalSaldo() {
      if (this.finances.length > 0) {
        return this.finances[this.finances.length - 1].saldo;
      }
      return 0;
    },
  },
  methods: {
    generatePDF() {
      const totalSaldo = this.finances[this.finances.length - 1].saldo;
      let tbody = '';
      this.finances.forEach((item) => {
        tbody += '<tr> ';
        tbody += `<td>${item.firstFinanceImportant ? '--' : item.chartOfAccountsAccount}</td> `;
        tbody += `<td> ${item.firstFinanceImportant ? '--' : this.format(item.documentDate)}</td> `;
        tbody += `<td> ${item.firstFinanceImportant ? '--' : this.format(item.deliveryDate)}</td> `;
        tbody += `<td> ${item.firstFinanceImportant ? '--' : item.bookingNoteItemSupplierInvoiceNumber}</td> `;
        tbody += `<td> ${item.firstFinanceImportant ? '--' : this.format(item.paymentDate)}</td> `;
        tbody += `<td class="text-right">${item.debit.toFixed(2).replace('.', ',')}</td> `;
        tbody += `<td class="text-right">${item.credit.toFixed(2).replace('.', ',')}</td> `;
        tbody += `<td class="text-right">${item.saldo.toFixed(2).replace('.', ',')}</td> `;
        tbody += '</tr> ';
      });
      const printContents = `
        <html>
          <head>
            <title>Finansije</title>
            <style>
              @page {
                size: auto;
                margin: 0mm;

                @bottom-center {
                    content: "Stranica " counter(page) " od " counter(pages);
                    font-family: 'Arial', sans-serif;
                    font-size: 12px;
                    margin: 10px 0;
                }
              }
              body {
                font-family: 'Arial', sans-serif;
                max-width: 800px;
                max-height: 1000px;
                overflow: hidden;
                margin: 20px 20px  20px 20px;
              }

              /* Stilovi za tablicu */
              table {
                width: calc(100% - 40px);
                border-collapse: collapse;
                margin: 5px 20px 5px 20px;
                font-size: 16px;
                text-align: left;
              }
              th, td {
                font-size: 10px;
                padding: 9px 10px;
                border: 1px solid #dddddd;
              }
              .text-center {
                text-align: center;
              }
              .text-right {
                text-align: right;
              }
              th {
                background-color: #f2f2f2;
                font-weight: bold;
              }
              tr:nth-child(even) {
                background-color: #f5f5f5;
              }
              .no-border {
                border: 0px;
                padding: 4px;
                margin: 0px;
              }
              /* Drugi stilovi za ispis */
            </style>
          </head>
          <body>
            <div style="position: relative">
              <table style="display: inline-block;border: 0.5px solid black; width: 200px; padding: 5px; margin: 5px; margin-left: 18px; margin-bottom: 5px;">
                <tr><td class="no-border"><b>${this.profile.userData.masterCompany.title ?? ''}</b></td></tr>
                <tr><td class="no-border"><b>${this.profile.userData.masterCompany.address ?? ''}</b></td></tr>
                <tr><td class="no-border"><b>${this.profile.userData.masterCompany.townTitle ?? ''}</b></td></tr>
              </table>
              <p style="position:absolute; bottom: -10px; right: 15px; font-size: 14px;">${this.format(Date.now())}</p>
            </div>
            <table style="display: inline-block;border: 0.5px solid black; border-bottom: 0px; width: calc(100% - 36px); height: 1px; margin-left: 18px; margin-right: 18px;">
            </table>
            <table style="margin-left: 9px; margin-right: 9px;">
              <tr>
                <td colspan="2" style="border: 0px; font-size: 20px; text-align:center;"><b>KARTICA KOMITENTA</b></td>
              </tr>
              <tr>
                <td style="border: 0px; font-size: 12px; width: 50%;"><b>Komitent: </b>${this.profile.userData.companyTitle ?? ''}</td>
                <td style="border: 0px; font-size: 12px; width: 50%; text-align: right;"><b>Datum od - do: </b>${this.format(this.dateFrom)} - ${this.format(this.dateTo)}</td>
              </tr>
            </table>

            <table style="margin-top: -5px;">
              <thead>
                <tr>
                  <th class= "text-center">KONTO</th>
                  <th class= "text-center">DATUM DOK.</th>
                  <th class= "text-center">DATUM KNJ.</th>
                  <th class= "text-center">BROJ RAČUNA</th>
                  <th class= "text-center">ROK PLAĆANJA</th>
                  <th class= "text-center">POTRAŽUJE</th>
                  <th class= "text-center">DUGUJE</th>
                  <th class= "text-center">IZNOS</th>
                </tr>
              </thead>
              <tbody>
                ${tbody}
              </tbody>
            </table>
            <br>
            <b style="margin-left: 20px; font-size: 13px;">Vaše ukupno zaduženje iznosi: </b> ${totalSaldo.toFixed(2).replace('.', ',')}
          </body>
        </html>
      `;

      const printFrame = document.getElementById('printFrame');
      printFrame.contentWindow.document.open();
      printFrame.contentWindow.document.write(printContents);
      printFrame.contentWindow.document.close();
      setTimeout(() => {
        printFrame.contentWindow.print();
      }, 100);
    },
    format(dateString) {
      return format(new Date(dateString), 'dd.MM.yyyy.');
    },
    disabledDatesFromDate(date) {
      const currentDate = new Date();

      return date > currentDate || date > this.dateTo;
    },
    disabledDatesToDate(date) {
      const currentDate = new Date();

      return date < this.dateFrom || date > currentDate;
    },
    getFinances() {
      const dateFrom = new Date(this.dateFrom);
      dateFrom.setHours(0, 0, 0);

      const dateTo = new Date(this.dateTo);
      dateTo.setHours(23, 59, 59);

      this.$store.dispatch(this.actionName, {
        customerId: this.profile.userData.externalCompanyId,
        dateFrom: this.dateFrom.toISOString(),
        dateTo: this.dateTo.toISOString(),
      });
    },
  },
  mounted() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    this.getFinances();
  },
};
</script>

<style lang="scss">
.date-range-wrapper {
  display: flex;
  align-items: center;
  gap: 1rem;
}
</style>
